<template>
  <van-popup
    v-model:show="show"
    position="center"
    :style="{
      minWidth: '90%',
      background: 'transparent',
      color: '#fff',
      overflow: 'hidden',
    }"
    @click-overlay="close"
  >
    <div class="deposit-popup">
      <div class="popup-header">
        <van-row style="display: flex;align-items: center;" >
        <van-col span="22">
        <span>{{ $t('deposit.firstDepositTitle') }}</span>
        </van-col>
        <van-col span="2">
        <img src="@/assets/profile/cs_close_n.png" alt="" width="20" @click="close"/>
        </van-col>
       </van-row> 
      </div>

      <div class="popupContainer">
        <div class="subText">{{ $t('deposit.getMoreBonus') }}</div>

        <van-row class="btnGroup">
          <van-col span="8" class="btnCol">
            <div class="click_btn" @click="callDoNotshow">
              {{ $t('deposit.dontShowAgain') }}
            </div>
          </van-col>
          <van-col span="8" class="btnCol">
            <div class="click_btn" @click="handleIgnoreToday">
              {{ $t('deposit.ignoreToday') }}
            </div>
          </van-col>
          <van-col span="8" class="btnCol">
            <div class="click_btn" @click="depositEnter">
              {{ $t('deposit.enter') }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </van-popup>

  <LoadingScreen ref="loadingRef" />
  <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>


<script setup lang="ts">
import { ref, defineExpose, defineEmits, PropType, computed, defineProps } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { checkDate } from '@/utils/commonFunction';
import { callFirstRechargePopupNotShow } from '@/api/deposit';
import { useUserStore } from '@/stores/user';
import { callDoNotshowFunc } from '@/view/deposit/supportScript';

const { t } = useI18n();
const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const open = () => {
    const ignoreDate = localStorage.getItem('ignoreDate') || ''
    if (ignoreDate) {
        if (checkDate(ignoreDate) == 0) {
            show.value = false
        } else {
            show.value = true
        }
    } else {
        show.value = true
    }
}

const close = () => {
    // userStore.setFirstRechargePopupShowStatus(0)
    let takeFirstDepositStatus = userStore.takeFirstDeposit
    if(!takeFirstDepositStatus){
        userStore.setisFirstRechargeRewardEligible(false)
    }else{
        userStore.setisFirstRechargeRewardEligible(true)
    }
    show.value = false  
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const handleIgnoreToday = () => {
    const today = new Date();
    const todayDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    localStorage.setItem('ignoreDate', todayDate);
    show.value = false
    userStore.setisFirstRechargeRewardEligible(false)
}
const depositEnter = () => {
    show.value = false
}
const callDoNotshow = () => {
    callDoNotshowFunc(callFirstRechargePopupNotShow,loadingRef,showSuccess,showError,userStore,show)
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.deposit-popup {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

/* 🟣 Gradient Header (new) */
.popup-header {
  background: linear-gradient(90deg, #c854ad 0%, #432e4f 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 14px;
  margin: 2;
}

/* 🟣 Content Area */
.popupContainer {
  background: #3e2e4b;
  padding: 15px;
  border-radius: 0 0 20px 20px; /* smooth continuation after header */
  /* width: 100%; */
  overflow: hidden;
}

.subText {
  color: #c08eba;
  font-size: 14px;
  font-style: italic;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 10px;
}

.btnGroup {
  padding: 10px;
}

.click_btn {
  color: #ffffff;
  font-size: 11.5px;
  background-image: linear-gradient(270deg, #e151a4, #e66fc8);
  border-radius: 5px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80%;
  height: 100%;
}

.btnCol {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

</style>